import React from 'react';
import { Paper } from '@lifeomic/chroma-react/components/Paper';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { GetClasses } from '@lifeomic/chroma-react/typeUtils';

export const useStyles = makeStyles((theme: Theme) => ({
  // Neutralizes the Paper chrome so mobile keeps its previous bare-container
  // look. Paper renders on mobile too: swapping it for a plain div would
  // change the element type and remount (and wipe the state of) the entire
  // survey subtree whenever the window crosses the mobile breakpoint.
  mobileRoot: {
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',
    background: 'transparent',
    boxShadow: 'none',
    borderRadius: 0,
    padding: 0,
  },
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(4),
  },
}));

export type RootClasses = GetClasses<typeof useStyles>;

export interface RootOwnProps {
  isMobile: boolean;
  children: any;
}

export type RootProps = RootOwnProps;

const Root = (props: RootProps) => {
  const classes = useStyles(props);

  return (
    <Paper className={props.isMobile ? classes.mobileRoot : classes.paper}>
      {props.children}
    </Paper>
  );
};

export default React.memo(Root);
